// extracted by mini-css-extract-plugin
module.exports = {"packageMain":"PurchaseFlow_packageMain__1HUS5","packages":"PurchaseFlow_packages__1qzoZ","pageState":"PurchaseFlow_pageState__3vaOh"};